// frontend/src/pages/Sabesp/components/InputBar.js
import React, { useRef } from "react";

export default function InputBar({ value, onChange, onSend, onCancel, isRunning }) {
  const textareaRef = useRef(null);

  function handleInput(e) {
    onChange(e.target.value);
    const el = textareaRef.current;
    if (el) {
      el.style.height = "auto";
      el.style.height = el.scrollHeight + "px";
    }
  }

  function handleKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  }

  return (
    <div className="sabesp-input-row-container">
      <p className="sabesp-input-warning">
        A IA pode cometer erros. Considere verificar as informações mais importantes.
      </p>
      <div className="sabesp-capsule-input-bar">
        <textarea
          ref={textareaRef}
          id="sabesp-prompt-input"
          rows={1}
          placeholder="Digite sua mensagem"
          autoComplete="off"
          value={value}
          onChange={handleInput}
          onKeyDown={handleKeyDown}
        />
        {isRunning && (
          <button className="sabesp-btn-input-cancel" title="Cancelar execução" onClick={onCancel}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            </svg>
          </button>
        )}
        <button className="sabesp-btn-input-send" onClick={onSend} disabled={isRunning || !value.trim()}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path>
          </svg>
        </button>
      </div>
    </div>
  );
}
